import React from "react";

const HowDoIFreezeMinor = (props: any) => {
    return (
        <div id="freeze-minor">
            <div>
                <p>
                    If you are a parent or guardian of a minor (under 16) and would like to freeze their TransUnion credit report, TransUnion can help. Here's what
                    you'll need to provide to TransUnion.
                </p>
            </div>

            <div className="margin-left-m margin-top-xs">
                <p>1. A written request to place a "protected consumer freeze" on the named individual's file.</p>
            </div>
            <div className="margin-left-m margin-top-xs">
                <p>
                    2. <strong>AND</strong> a copy of one piece of documentation that provides 'sufficient proof of authority' that you have authority to act on
                    behalf of the minor or dependent such as:
                </p>
                <ul>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>an order issued by a court of law</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>a lawfully executed and valid power of attorney</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>
                                    a document issued by a Federal, State, or local government agency in the United States showing proof of parentage, including a
                                    birth certificate
                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>
                                    with respect to a protected consumer who has been placed in a foster care setting, a written communication from a county welfare
                                    department or its agent or designee, or a county probation department or its agent or designee, certifying that the protected
                                    consumer is in a foster care setting under its jurisdiction.
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div className="margin-left-m margin-top-xs">
                <p>
                    3. <strong>AND</strong> information or a copy of documentation that provides 'sufficient proof of identification' that you are who you really
                    are, and information or a copy of documentation that the minor/dependent is who they really are, such as:
                </p>
                <ul>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>
                                    with respect to a protected consumer who has been placed in a foster care setting, a written communication from a county welfare
                                    department or its agent or designee, or a county probation department or its agent or designee, certifying that the protected
                                    consumer is in a foster care setting under its jurisdiction.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>a Social Security number or a copy of a Social Security card issued by the Social Security Administration</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className={"col-xs-1"} style={{ maxWidth: "20px" }}>
                                <p>
                                    <strong>&#x2022;</strong>
                                </p>
                            </div>
                            <div className={"col-xs-11"}>
                                <p>a certified or official copy of a birth certificate issued by the entity authorized to issue the birth certificate</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <p>Please only send copies of documents, not original documents.</p>
            <div>
                <p>Send everything to TransUnion's address below:</p>
            </div>
            <div>
                <strong>TransUnion</strong>
            </div>
            <div>
                <strong>P.O. Box 380</strong>
            </div>
            <div>
                <strong>Woodlyn, PA 19094</strong>
            </div>
            <p></p>
            <p>
                Please note: Consumers are not able to place a protected consumer freeze via phone or online at this time due to the documentation requirements.
                TransUnion accepts either standard or certified mail.
            </p>
        </div>
    );
};

export default HowDoIFreezeMinor;
